import { generateHapticFeedback, type HapticFeedbackType } from '@apps-in-toss/web-framework';
import { isInTossApp } from './env';

// 게임 이벤트 → 햅틱 타입 매핑
export type HapticEvent =
  | 'buy'         // 매수 체결 (약함)
  | 'sellWin'     // 매도 수익 (성공)
  | 'sellLoss'    // 매도 손실 (중간)
  | 'liquidate'   // 강제청산 (에러)
  | 'rankUp'      // 랭킹 진입 (성공)
  | 'adReward'    // 광고 보상 (약함)
  | 'tap';        // 일반 탭

const MAP: Record<HapticEvent, HapticFeedbackType> = {
  buy:        'tickWeak',
  sellWin:    'success',
  sellLoss:   'basicMedium',
  liquidate:  'error',
  rankUp:     'confetti',
  adReward:   'tickMedium',
  tap:        'tap',
};

export function haptic(event: HapticEvent): void {
  if (!isInTossApp()) return;
  try {
    void generateHapticFeedback({ type: MAP[event] });
  } catch {
    /* 환경 미지원 — 무시 */
  }
}
